import { z } from 'zod';

/**
 * The PinGo web running inside the mobile app's in-app web screen (CLAUDE.md §15 #402). The app
 * appends `PinGoApp/<version>` to the WebView user agent; the web then hides "open in browser" /
 * "install app" banners and hands file downloads to the app with `window.ReactNativeWebView
 * .postMessage(JSON.stringify(EmbedMessage))` — a WebView cannot save a blob: URL.
 */
export const EMBED_UA_TOKEN = 'PinGoApp';

/** an api path the app fetches with its own USER bearer (never a session token in the message) */
export const EmbedApiPath = z
  .string()
  .max(2000)
  .regex(/^\/api\/v1\/[A-Za-z0-9/_.~%:-]*(\?[^#\s]*)?$/);

export const EmbedFileName = z
  .string()
  .min(1)
  .max(200)
  .regex(/^[^/\\\0]+$/);

export const EmbedMessageSchema = z.discriminatedUnion('type', [
  /** binary export (PDF/XLSX/QR PNG): the app downloads `path` and opens the share sheet */
  z.object({ type: z.literal('pingo.download'), path: EmbedApiPath, filename: EmbedFileName }),
  /** a file the page built itself (billing CSV): saved as text and shared */
  z.object({
    type: z.literal('pingo.save'),
    filename: EmbedFileName,
    mime: z.string().max(100),
    text: z.string().max(5_000_000),
  }),
]);
export type EmbedMessage = z.infer<typeof EmbedMessageSchema>;
